module.exports = __webpack_public_path__ + "static/media/logo-lazada.7b360f8e.png";